import { render, staticRenderFns } from "./collection.vue?vue&type=template&id=704ec469&scoped=true&"
import script from "./collection.vue?vue&type=script&lang=ts&"
export * from "./collection.vue?vue&type=script&lang=ts&"
import style0 from "./collection.vue?vue&type=style&index=0&id=704ec469&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704ec469",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDivider,VImg,VTooltip})
